/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { AlertWithTimestamp } from '../components/AlertWithTimestamp';
import history from './History';
import { trackEvent } from './MatomoConfig';
import { extractApiErrorMessage } from './extractApiErrorMessage';

const api = axios.create({
  responseType: 'json',
});

api.interceptors.request.use(
  config => {
    config.headers = {
      Accept: config.download ? 'application/octet-stream' : 'application/json',
      Authorization: config.token
        ? `${config.uploadToken ? '' : 'Bearer '}${config.token}`
        : config.expectToken
          ? `Bearer ${localStorage.getItem('autenticacao.token')}`
          : config.uploadToken
            ? localStorage.getItem('autenticacao.token')
            : 'Basic bXktdHJ1c3RlZC1jbGllbnQ6c2VjcmV0',
      'Content-Type': config.headers.contentType ? config.headers.contentType : 'application/json; charset=utf-8',
    };
    return config;
  },
  error => Promise.reject(error),
);

api.interceptors.response.use(
  response => response,
  error => {
    const response = error?.response;
    const status = error?.response?.status;
    const url = error?.config?.url;

    if (response && status === 400) {
      const skipAutoAlertEndpoints = ['/all-products/update/price', '/negotiations/datapoints/add', '/all-products/apply', '/monitoramentos'];
      const shouldSkipAlert = skipAutoAlertEndpoints.some(endpoint => url?.includes(endpoint));

      if (!shouldSkipAlert) {
        let res;
        if (response.request.responseType === 'arraybuffer' && response.data.toString() === '[object ArrayBuffer]') {
          res = JSON.parse(Buffer.from(response.data).toString('utf8'));
        } else {
          res = response.data;
        }
        AlertWithTimestamp({ message: extractApiErrorMessage(res) || res.error_description || res.message });
      }
    }
    if (response && status === 406) {
      const skipAutoAlertEndpoints = ['/all-products/apply', '/monitoramentos'];
      const shouldSkipAlert = skipAutoAlertEndpoints.some(endpoint => url?.includes(endpoint));

      if (!shouldSkipAlert) {
        let res;
        if (response.request.responseType === 'arraybuffer' && response.data.toString() === '[object ArrayBuffer]') {
          res = JSON.parse(Buffer.from(response.data).toString('utf8'));
        } else {
          res = response.data;
        }
        AlertWithTimestamp({ message: extractApiErrorMessage(res) || res.error_description || res.message });
      }
    }
    if (response && status === 401) {
      if (
        window.location.pathname !== '/login' &&
        window.location.pathname !== '/nova-senha' &&
        window.location.pathname !== '/recuperar-senha' &&
        window.location.pathname !== '/criar-conta' &&
        window.location.pathname !== '/link-acesso' &&
        !window.location.pathname.includes('/free')
      ) {
        history.push('/login');
      }
    }
    if (response && status === 403) {
      const shouldSkipAlert = url?.includes('/monitoramentos');

      if (!shouldSkipAlert) {
        const msg403 = extractApiErrorMessage(response?.data) ?? response?.data?.message;
        if (msg403) {
          AlertWithTimestamp({ message: msg403 });
        }
      }
    }
    if (status === 404) {
      if (
        response.config.url.includes('infopanel-competitivity-engine') ||
        response.config.url.includes('infopanel-industry-competitivity-engine') ||
        response.config.url.includes('/monitoramentos')
      ) {
        return;
      }
      AlertWithTimestamp({ message: 'Erro inesperado. Tente novamente' });
      trackEvent('Erro', status, url);
    }
    if (response && status === 412) {
      const ignoredEndpoints = ['/cadastros-api/autenticacao', '/monitoramentos']; // Endpoints que não devem disparar alerta

      if (!ignoredEndpoints.some(endpoint => response.config.url.includes(endpoint))) {
        AlertWithTimestamp({
          message:
            extractApiErrorMessage(response.data) ||
            response.data.error_description ||
            response.data.message ||
            response.data.mensagem ||
            response.data[0]?.message,
        });
      }

      return Promise.reject(error);
    }
    if (response && status === 500) {
      const skipAutoAlertEndpoints = ['/price-adherence/uploads-in-use', '/monitoramentos'];
      const shouldSkipAlert = skipAutoAlertEndpoints.some(endpoint => url?.includes(endpoint));

      if (!shouldSkipAlert) {
        const msg500 = extractApiErrorMessage(response?.data);
        AlertWithTimestamp({
          message: msg500 || 'Instabilidade no sistema. Tente novamente mais tarde',
        });
      }

      trackEvent('Erro', status, url);
    }
    if (!response) {
      return Promise.reject(error);
    }
    if (response?.data?.status) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export default api;
